<template>
  <fieldset>
    <!-- Currency Selector -->
    <RevInputSelect
      id="backbox-price-range-currency"
      v-model="backboxPriceRangeCurrencyValue"
      :label="i18n(sharedTranslations.backboxPriceRangeTypeCurrency)"
      :options="currencyOptions"
    />
    <div class="mt-16 flex gap-4">
      <RevInputText
        id="backbox-price-min-range"
        v-model="backboxPriceMinRangeValue"
        :label="
          i18n(sharedTranslations.backboxPriceRangeTypeMinAmount, {
            currency: backboxPriceRangeCurrencyValue
              ? i18n.currencySymbol(backboxPriceRangeCurrencyValue as Currency)
              : i18n.currencySymbol(currencyOptions[0].value),
          })
        "
        type="number"
      />
      <RevInputText
        id="backbox-price-max-range"
        v-model="backboxPriceMaxRangeValue"
        :label="
          i18n(sharedTranslations.backboxPriceRangeTypeMaxAmount, {
            currency: backboxPriceRangeCurrencyValue
              ? i18n.currencySymbol(backboxPriceRangeCurrencyValue as Currency)
              : i18n.currencySymbol(currencyOptions[0].value),
          })
        "
        type="number"
      />
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import type { Currency } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevInputText } from '@ds/components/InputText'

import sharedTranslations from '../../../Filters.translations'
import type { InitialFilterValues } from '../../../Filters.types'

const i18n = useI18n()

defineProps<{
  currencyOptions: { label: string; value: Currency }[]
}>()

const backboxPriceMinRangeValue = defineModel<
  InitialFilterValues['backboxPriceMinRange']
>('backboxPriceMinRangeValue')
const backboxPriceMaxRangeValue = defineModel<
  InitialFilterValues['backboxPriceMaxRange']
>('backboxPriceMaxRangeValue')
const backboxPriceRangeCurrencyValue = defineModel<
  InitialFilterValues['backboxPriceCurrencyCode']
>('backboxPriceCurrencyCode', { default: '' })
</script>
